import React, {useState} from 'react';
import ModalContainer from "../../common/modal_container";
import {with_comma} from "../../../util/comma";
import Btn from "../../layout/Btn";
import partner from "../../../_asset/media/partner.png";
import Container from "../../layout/Container";
import { Logo_2 } from '../../common/logo';

function RequestDeposit({title}: {title: string}) {
    const [popShow, setPopShow] = useState<boolean>(false)

    return (
        <>
            <p className={"--pointer"} onClick={e=>setPopShow(true)}>{title}</p>
            <DepositModal popShow={popShow} setPopShow={setPopShow} title={title}/>
        </>
    );
}

export default RequestDeposit;

export function DepositModal({popShow, setPopShow, title}: {popShow: boolean; setPopShow: Function; title: string}){
    return (
        <ModalContainer
            show={popShow}
            setShow={setPopShow}
            closeBtn
            className={'deposit-popup'}
            title={<><p>입금신청</p><Logo_2 /></>}
        >
            <div className={'warning'}>
                <p><b>주의사항</b></p>
                <p>23:50 ~ 00:30, 휴일 다음 첫 영업일 새벽에는 <b>은행점검으로 인해 계좌이체가 지연</b>될 수 있습니다.</p>
                <p>위 시간 이외에도 몇몇 은행은 추가적 점검시간이 따로 있으니 이점 유념하시기 바랍니다.</p>
            </div>
            <Table />
            <div className={"btn-area"}>
                <Btn className={"green"}>입금신청</Btn>
            </div>

            {/* <img src={partner} alt="partner"/> */}
        </ModalContainer>
    )
}

function Table() {
    const [amount, setAmount] = useState<number>(0)
    function addAmount(num: number){
        setAmount(amount + num)
    }

    return (
        <div className={"deposit-table"}>
            <table>
                <tbody>
                <tr>
                    <th>입금금액*</th>
                    <td>
                        <div className={'amount-td'}>
                            <div className={"amount"}>
                                <input type={"text"} name="amount" value={with_comma(amount)} readOnly={true} />
                            </div>
                            <div className={"deposit-btn"}>
                                <span onClick={e=> addAmount(10000)}>10,000</span>
                                <span onClick={e=> addAmount(50000)}>50,000</span>
                                <span onClick={e=> addAmount(100000)}>100,000</span>
                                <span onClick={e=> addAmount(500000)}>500,000</span>
                                <span onClick={e=> setAmount(0)}>초기화</span>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th>입금은행*</th>
                    <td>
                        <input type="text" name={"deposit-bank"} placeholder={"고객센터문의"} readOnly={true}/>
                    </td>
                </tr>
                <tr>
                    <th>계좌번호*</th>
                    <td>
                        <input type="text" name={"deposit-number"} placeholder={"고객센터문의"} readOnly={true}/>
                    </td>
                </tr>
                <tr>
                    <th>입금자명*</th>
                    <td>
                        <input type="text" name={"deposit-owner"} placeholder={"고객센터문의"} readOnly={true}/>
                        <div className={'tip'}>입금자명과 출금시 예금주명이 동일하지 않은 경우 출금처리가 진행되지 않습니다.</div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    )
}